var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiPopover from '@material-ui/core/Popover';
/**
 * Kareo wrapped component of the Material-ui Popover. The prop API has been limited to props defined in PopoverProps.
 *
 * A Popover can be used to display some content on top of another.
 *
 * Material-UI Popover: [Docs](https://v4.mui.com/components/popover/), [API](https://v4.mui.com/api/popover/)
 *
 * @storybook: [Popover](http://design.kareoprod.ent/design-system/?path=/story/components-utils--popover)
 */
var Popover = React.forwardRef(function (props, ref) {
    return React.createElement(MuiPopover, __assign({}, props, { ref: ref }));
});
Popover.displayName = 'KareoPopover';
export default Popover;
